import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { Button, HSpacer, Input, VSpacer } from "@/components/DesignSystem";
import { RedemptionSku }
  from "@/pages/Admin/HierarchyOfRetailers/Wallet/CreateOrEditSubwalletDialog";

interface RedemptionSkuInputProps {
  existingRedemptionSku?: RedemptionSku,
  isExternalIdReadonly: boolean,
  onCancel: () => void,
  onSave: (externalId: string, id: string | null, name: string) => void,
  redemptionSkus: RedemptionSku[],
}

export const RedemptionSkuInput = ({
  existingRedemptionSku,
  isExternalIdReadonly,
  onCancel,
  onSave,
  redemptionSkus,
} : RedemptionSkuInputProps) => {
  const [name, setName] = useState('');
  const [externalId, setExternalId] = useState('');

  useEffect(() => {
    setName(existingRedemptionSku?.name ?? '');
    setExternalId(existingRedemptionSku?.externalId ?? '');
  }, [
    existingRedemptionSku,
    existingRedemptionSku?.name,
    existingRedemptionSku?.externalId,
  ]);
  
  const showRedemptionSkuSaveAndCancelButtons = !!redemptionSkus.length ||
    (!!name || !!externalId);

  const isExternalIdValid = !!externalId &&
    externalId.length <= 100 &&
    name.length <= 100 &&
    !redemptionSkus
      .filter(r => r.externalId !== existingRedemptionSku?.externalId)
      .find(r => r.externalId === externalId);

  const isNameValid = !!name && name.length <= 100;

  return (
    <>
      <Stack alignItems="center" direction="row" gap="16px">
        <Input
          label="Product name"
          maxLength={100}
          onChange={(e) => setName(e.target.value)}
          testID="redemption-sku-product-name-input"
          value={name}
          variant="outlined"
        />
        <Input
          disabled={isExternalIdReadonly}
          error={externalId.length > 100 || (!!externalId && !isExternalIdValid)}
          label={`ERP ID (SKU) ${isExternalIdReadonly ? '(Read only)' : '' }`}
          maxLength={100}
          onChange={(e) => setExternalId(e.target.value)}
          testID="redemption-sku-product-erp-id-input"
          value={externalId}
          variant="outlined"
        />
      </Stack>
      <VSpacer size="4" />
      {showRedemptionSkuSaveAndCancelButtons && (
        <Stack direction="row">
          <Button
            onClick={() => {
              setName('');
              setExternalId('');
              onCancel();
            }}
            square
            sx={{ height: '32px' }}
            testID="cancel-redemption-sku-button"
            variant="outlined"
          >
            Cancel
          </Button>
          <HSpacer size="4" />
          <Button
            disabled={!isNameValid || !isExternalIdValid}
            onClick={() => {
              onSave(externalId, existingRedemptionSku?.id ?? null, name);
            }}
            square
            sx={{ height: '32px' }}
            testID="create-redemption-sku-button"
          >
            Save
          </Button>
        </Stack>
      )}
    </>
  );
};